import {NgModule} from '@angular/core';
import {ArticleBlockSponsorBarComponent} from './article-block-sponsor-bar.component';

@NgModule({
  declarations: [ArticleBlockSponsorBarComponent],
  exports: [ArticleBlockSponsorBarComponent],
})
export class ArticleBlockSponsorBarModule {}
